module.exports = __webpack_public_path__ + "static/img/slide_small1.1887576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide_small1.png
// module id = p2lZ
// module chunks = 5